export default {
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    backgroundColor: 'transparent',
    margin: [5, 5, 5, 5],
  },
  credits: {
    enabled: false,
  },
  title: {
    text: null,
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      size: '100%',
      innerSize: '83%',
      slicedOffset: '1',
      borderColor: '#112b3f',
      borderWidth: '2px',
      dataLabels: {
        enabled: false,
      },
    },
    series: {
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  },
  series: [
    {
      type: 'pie',
      name: 'Asset Allocation',
      data: [],
    },
  ],
};
